import { axiosInstance as axios } from 'helpers/axiosInstance';
import logger from 'helpers/logger';
import { queryCmsContent } from './_api';
import { articleInfoColumnMapper } from 'helpers/mappers';

//CMS is not exposed to the website, therefore we fetch the articles via a Next.JS API
export const getArticlesFromApi = async (
	rootId: number,
	limit: number,
	offset: number,
	preview: boolean,
	previewData: Content.PreviewData,
): Promise<Articles.Article[]> => {
	return axios({
		url: `/api/articles`,
		method: 'POST',
		headers: {},
		data: {
			rootId,
			limit,
			offset,
			preview,
			previewData,
		},
	})
		.then((res) => {
			const articles: Articles.Article[] = res.data?.articles;
			return articles;
		})
		.catch((error) => {
			const message = error?.response?.data?.message ?? error;
			logger.error(`getArticlesFromApi() \nArticles retrieval from API failed \n${message}`);
			throw message;
		});
};

export const getArticlesFromCms = async (
	rootId: number,
	limit: number,
	offset: number,
	preview: boolean,
	previewData: Content.PreviewData,
): Promise<Articles.Article[]> => {
	const graphQLquery = `{
		pageSearch(documentType:["articlePage"] rootIds:[${rootId}] limit:${limit} offset:${offset})
			{
				pages {
					name
					url
					id
					properties
				}
			}
		}`;

	const profiler = logger.startTimer();
	try {
		const results = await queryCmsContent({
			query: graphQLquery,
			preview,
			previewData,
			method: 'POST',
		});

		const articles = results.pageSearch?.pages.map((page) => ({
			mainHeading: page.properties.mainHeading,
			url: page.url,
			teaser: page.properties.teaser,
			image: page.properties.image,
			featuredImage: page.properties.featuredImage,
			mobileImage: page.properties.mobileImage,
			articleInfo: page.properties.articleInfo.map(articleInfoColumnMapper),
			location: page.properties.location,
		}));

		return articles;
	} finally {
		profiler.done({ message: 'getArticles', level: 'debug' });
	}
};
